import { useNavigate } from 'react-router-dom'
import type { DashboardLabResult } from '../../store/dashboardSlice'

interface LabResultsAwaitingReviewProps {
  results: DashboardLabResult[]
}

function formatDate(dateStr: string): string {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function LabResultsAwaitingReview({ results }: LabResultsAwaitingReviewProps) {
  const navigate = useNavigate()

  return (
    <div data-testid="lab-results-awaiting-review">
      <h2 className="text-[14px] font-medium text-text-primary mb-3">Lab Results Awaiting Review</h2>

      {results.length === 0 ? (
        <p className="text-[12px] text-text-muted py-4 text-center" data-testid="lab-results-empty">
          No lab results awaiting review
        </p>
      ) : (
        <div className="flex flex-col">
          {/* Header */}
          <div
            className="dash-lr-header grid items-center h-9 text-[11px] font-medium text-text-muted uppercase tracking-wide"
            style={{ gridTemplateColumns: '1fr 1fr 120px 130px' }}
          >
            <span className="px-2">Patient</span>
            <span className="px-2">Test Name</span>
            <span className="px-2">Date Submitted</span>
            <span className="px-2">Status</span>
          </div>

          {/* Rows */}
          {results.map((lr) => (
            <div
              key={lr.id}
              data-testid={`lab-result-row-${lr.id}`}
              onClick={() => navigate(`/lab-work/${lr.id}`)}
              className="dash-lr-row grid items-center h-[44px] text-[13px] text-text-primary hover:bg-hover transition-colors duration-100 cursor-pointer"
              style={{ gridTemplateColumns: '1fr 1fr 120px 130px' }}
            >
              <span className="px-2 font-[500] truncate" data-testid="lab-patient-name">
                {lr.patient_name}
              </span>
              <span className="px-2 text-[12px] text-text-secondary truncate" data-testid="lab-test-name">
                {lr.test_name}
              </span>
              <span className="px-2 text-[12px] text-text-muted" data-testid="lab-date-submitted">
                {formatDate(lr.date_ordered)}
              </span>
              <span className="px-2" data-testid="lab-status">
                <span className="inline-flex items-center h-5 px-1.5 rounded-[3px] text-[11px] font-medium bg-[#f5ecd8] text-status-warning">
                  {lr.status}
                </span>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
